import type { Directive } from 'vue'
import { usePermissionStore } from '@/stores/permission'
import { sessionStorage } from '@/utils/storage'
export const permission: Directive = {
  mounted(el, binding) {
    const permissionStore = usePermissionStore()
    const { value } = binding
    const expired = sessionStorage.get('isSchoolExpired')
    // console.log('School page isExpired:', expired)

    // console.log("检查按钮权限:", {
    //   permission: value,
    //   currentPermissions: permissionStore.currentPagePermissions,
    //   hasPermission: permissionStore.hasPermission(value)
    // })

    // 获取按钮状态
    const buttonState = permissionStore.getButtonState(value)
    // console.log("按钮状态:", {
    //   permission: value,
    //   state: buttonState
    // })
    
    // 如果指定了权限值，但没有对应权限或状态为隐藏，则移除元素
    // if ((value &&  buttonState === 0) || expired) {
    //   el.parentNode?.removeChild(el)
    // }

    if (expired || !permissionStore.hasPermission(value)) {//学校过期 隐藏按钮
      el.parentNode?.removeChild(el)
    }
  }
} 